export default {
    data() {
        return {
            filters: {},
            filterQueryString: '',
            filtersCleared: false
        }
    },
    created() {
        if (this.savedFilters) {
            this.filters = Object.assign({}, this.savedFilters)
        }
    },
    methods: {
        createFilterQuery(item, filters) {
            this.filterQueryString ?
                this.filterQueryString = this.filterQueryString.concat('&', `${item}=${filters[item]}`) :
                this.filterQueryString = `${item}=${filters[item]}`
        },
        clearFilter(filterName) {
            this.filters[filterName] = null
            this.changeFilter()
        },
        saveFiltersCleared() {
            this.filtersCleared = true
        },
        resetFiltersCleared() {
            this.filtersCleared = false
        }
    }
}
